import { render, staticRenderFns } from "./BCXDatepickerField.vue?vue&type=template&id=9d5cdc00"
import script from "./BCXDatepickerField.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXDatepickerField.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXDatepickerField.vue?vue&type=style&index=0&id=9d5cdc00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports